import queryString from 'query-string';
import callApi, { CallApiResult } from 'src/api';
import { LanguageKeys } from 'src/core/provider/AppMeta';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

/* Fetch Events */

export const fetchEvents = (pageable: PageableQueryParams = {}): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const endpoint = `/api/events${query}`;
    return callApi(endpoint);
};

/* Fetch Event languages */

export const fetchEventLanguages = (): Promise<CallApiResult> => {
    const endpoint = '/api/event/current/customerEventLanguages';
    return callApi(endpoint, { method: 'GET' });
};

/* Set Event languages */

export const submitSelectEventLanguages = (data: LanguageKeys[]): Promise<CallApiResult> => {
    const endpoint = '/api/event/current/customerEventLanguages';
    return callApi(endpoint, { method: 'PUT', data });
};
